import { FilledStarIcon } from '@/components/icons';
import clsx from 'clsx';

type Props = {
    active?: boolean;
};

export const Star = ({ active = false }: Props) => {
    return (
        <div
            className={clsx('h-[calc(20*var(--vh-unit))] w-[calc(20*var(--vw-unit))]', {
                'text-not-contrast-yellow-ffc700': active,
                'text-not-contrast-gray-ccc': !active,
            })}
        >
            <FilledStarIcon fill="currentColor" width={20} height={20} />
        </div>
    );
};
